(function ($) {
  'use strict';
  this.LaVuelta2023 = function () {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.dispatchEventType) {
        window.dispatchEventType(
          document,
          'SkodaAnalytics:Promotions:AddElements',
          undefined,
          undefined,
          undefined,
          {
            elements: document.querySelectorAll('#product-banner a'),
            context: 'La Vuelta 2023',
          }
        );
      }
    });
  };
}).bind(window)(jQuery);
